<template>
    <v-layout column fill-height>
        <breadcrumbs :guia="guia" titulo="Colaboradores" descricao="Gerencie seus colaboradores e defina as permissões de acesso." />

        <v-layout class="main">
            <membros />
        </v-layout>

    </v-layout>
</template>


<script>
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";

import membros from "@/components/portal/colaboradoresCadastroUnico/Membros";

export default {
  components: {
    breadcrumbs,
    membros
  },
  data() {
    return {
        guia: "Colaboradores Novo > Membros"
    }
  },
  methods: {
 }
};
</script>